import { Injectable, resource } from '@angular/core';
import { RestDatasource } from '@core/api/rest.datasource';
import { Rolle } from '@features/roller/rolle.model';

@Injectable({
  providedIn: 'root'
})
export class RolleDatasource extends RestDatasource<Rolle> {
  override endpoint = '/v2/roller';

  data = resource({
    loader: async ({ abortSignal }) => {
      return await this.getList({
        sortBy: 'navn'
      }, abortSignal);
    }
  });

}
